export * as factories from "./factories";
export { BaraVault__factory } from "./factories/BaraVault__factory";
export { ERC20__factory } from "./factories/ERC20__factory";
export { WCRO__factory } from "./factories/WCRO__factory";
